import { db } from '@/firebase/db';

const VENUE_COLLECTION = 'venues';

export default {
  createVenue(item) {
    return db.collection(VENUE_COLLECTION).add(item);
  },
  updateVenue(item) {
    return db.collection(VENUE_COLLECTION).doc(item.id).set(item);
  },
  deleteVenue(item) {
    return db.collection(VENUE_COLLECTION).doc(item.id).delete();
  }
}